export const UNDER_REVIEW_ACCOUNT_STATUS = [
    'KYC_PENDING',
    'NOT_ELIGIBLE', // you’re not eligible for emma pots feature
    'OPENING_IN_PROGRESS', // please wait we’re opening your account
    'CLOSING_IN_PROGRESS', // we’re closing your account
    'CLOSED', // your pots account is closed
    'FROZEN', // your account is temporary frozen
];
export var VerificationType;
(function (VerificationType) {
    VerificationType["Identity"] = "IDENTITY";
    VerificationType["Trading"] = "TRADING";
})(VerificationType || (VerificationType = {}));
export var KYCStatus;
(function (KYCStatus) {
    KYCStatus["Success"] = "SUCCESS";
    KYCStatus["Fail"] = "FAIL";
    KYCStatus["Pending"] = "PENDING";
})(KYCStatus || (KYCStatus = {}));
export var SingleInputScreenFlows;
(function (SingleInputScreenFlows) {
    SingleInputScreenFlows["editPotName"] = "EditPotName";
})(SingleInputScreenFlows || (SingleInputScreenFlows = {}));
export const roundUpOptions = [1, 2, 3, 4, 5];
export var SavingsPlanRuleType;
(function (SavingsPlanRuleType) {
    SavingsPlanRuleType["AUTOMATED"] = "AUTOMATED";
    SavingsPlanRuleType["ROUND_UP"] = "ROUND_UP";
    SavingsPlanRuleType["CUSTOM"] = "CUSTOM";
})(SavingsPlanRuleType || (SavingsPlanRuleType = {}));
export var PauseAutosaveExpiryDateType;
(function (PauseAutosaveExpiryDateType) {
    PauseAutosaveExpiryDateType["ONE_WEEK"] = "ONE_WEEK";
    PauseAutosaveExpiryDateType["TWO_WEEKS"] = "TWO_WEEKS";
    PauseAutosaveExpiryDateType["MONTH"] = "MONTH";
    PauseAutosaveExpiryDateType["CUSTOM"] = "CUSTOM";
    PauseAutosaveExpiryDateType["NO_LIMIT"] = "NO_LIMIT";
})(PauseAutosaveExpiryDateType || (PauseAutosaveExpiryDateType = {}));
